export default __webpack_public_path__ + "static/media/img.c111d92f.mp4";